/** 감사 화면 자동 복귀 대기(초) — QR 없을 때(기존) */
export const THANKS_SECONDS = 6;
/**
 * QR 이 남아 있을 때 — 손님이 마지막으로 찍을 시간 (BOOTH-63). 너무 길면 떠난 손님의 사진 링크가
 * 다음 사람에게 노출되므로 "마지막 기회" 만큼만. 현장 피드백은 이 숫자 하나로 조정한다.
 */
export const THANKS_WITH_QR_SECONDS = 30;

export function thanksSeconds(hasQr: boolean): number {
  return hasQr ? THANKS_WITH_QR_SECONDS : THANKS_SECONDS;
}
